import React from 'react';
import { Session } from '@supabase/supabase-js';
import { TooltipProvider } from '@/components/ui/tooltip';
import ResponsiveHeader from '../navigation/ResponsiveHeader';
import Breadcrumbs from '../navigation/Breadcrumbs';
import FloatingAIButton from '../navigation/FloatingAIButton';
import { UnifiedBottomNav } from '../navigation/UnifiedBottomNav';

interface ModernAppLayoutProps {
  children: React.ReactNode;
  session: Session | null;
}

const ModernAppLayout = ({ children, session }: ModernAppLayoutProps) => {
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/20 overflow-x-hidden">
        {/* Responsive Header */}
        <ResponsiveHeader />
        
        {/* Breadcrumb Navigation */}
        <div className="pt-16">
          <Breadcrumbs />
        </div>
        
        {/* Main Content */}
        <main className="container max-w-7xl mx-auto px-3 sm:px-4 py-4 sm:py-6 md:py-8 min-h-[calc(100vh-4rem)] pb-24 md:pb-8 overflow-x-hidden">
          {children}
        </main>
        
        {/* Mobile Bottom Navigation */}
        <UnifiedBottomNav session={!!session} />
        
        {/* Floating AI Assistants Button */}
        <FloatingAIButton />
      </div>
    </TooltipProvider>
  );
};

export default ModernAppLayout;